// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2.0043 0.589966L2.00015 0.585815L0.585938 2.00003L1.58591 3H1V9L7.58591 9L9.58628 11.0004H1V21L19.5859 21L22.0002 23.4142L23.4101 22.0043L2 0.594267L2.0043 0.589966ZM9 17.0001H4L4 15.0001L9 15.0001V17.0001Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 18.7658V11.0004H15.2345L23 18.7658Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13.2342 9L23 9V3H7.23416L13.2342 9Z"}}]};

const CreditcardOffFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'creditcard-off-filled',
    ref,
    icon: element,
  },
));

CreditcardOffFilledIcon.displayName = 'CreditcardOffFilledIcon';

export default CreditcardOffFilledIcon;
